module.exports = __webpack_public_path__ + "img/madagascar.38486467.svg";